module.exports = __webpack_public_path__ + "static/media/giant-snakehead.79a1ca56.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/giant-snakehead.png
// module id = 314
// module chunks = 0